import { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { useTheme } from "@mui/material/styles";

const GraphCategorySplit = props => {
  const theme = useTheme();

  const [labels, setLabels] = useState([]);
  const [dataRevenue, setDataRevenue] = useState([]);
  const [dataCommission, setDataCommission] = useState([]);
  const [dataExpenses, setDataExpenses] = useState([]);
  const [dataCostCenter, setDataCostCenter] = useState([]);

  useEffect(() => {
    loadCategoryGraphData();
  }, [props.bookings]);

  const loadCategoryGraphData = () => {
    // Create categories
    let categories = [];
    let counter = 0;
    let bookings = [];
    for (let booking of props.bookings) {
      if (booking.status === "booked" || booking.status === "closed") {
        bookings.push(booking);
      }
    }
    // For loop through list of the bookings to fill category revenue and commission
    if (props.type === "CategoryRevenue") {
      for (let booking of bookings) {
        if (booking.event.event_categories[0]) {
          let change = false;
          counter++;
          if (categories.length === 0) {
            let newCategory = {
              name: booking.event.event_categories[0].display_name,
              totalRevenue: booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees)
            };
            categories.push(newCategory);
          }
          Loop1: for (let category of categories) {
            if (counter === 1) {
              change = true;
              break Loop1;
            }
            if (booking.event.event_categories[0].display_name === category.name) {
              category.totalRevenue +=
                booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees);
              change = true;
            }
          }
          if (change === false) {
            let newCategory = {
              name: booking.event.event_categories[0].display_name,
              totalRevenue: booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees)
            };
            categories.push(newCategory);
          }
        }
      }

      // Prepare graph options and data
      let dataRevenue = [];
      let labels = [];
      for (let category of categories) {
        dataRevenue.push(category.totalRevenue.toFixed(2));
        labels.push(category.name);
      }
      setDataRevenue(dataRevenue);
      setLabels(labels);
    }
    if (props.type === "CategoryCommission") {
      for (let booking of bookings) {
        if (booking.event.event_categories[0]) {
          let change = false;
          counter++;
          if (categories.length === 0) {
            let newCategory = {
              name: booking.event.event_categories[0].display_name,
              totalCommission:
                booking.commission_booking.total_hotel_commission === null
                  ? 0
                  : parseFloat(booking.commission_booking.total_hotel_commission)
            };
            categories.push(newCategory);
          }
          Loop1: for (let category of categories) {
            if (counter === 1) {
              change = true;
              break Loop1;
            }
            if (booking.event.event_categories[0].display_name === category.name) {
              category.totalCommission +=
                booking.commission_booking.total_hotel_commission === null
                  ? 0
                  : parseFloat(booking.commission_booking.total_hotel_commission);
              change = true;
            }
          }
          if (change === false) {
            let newCategory = {
              name: booking.event.event_categories[0].display_name,
              totalCommission:
                booking.commission_booking.total_hotel_commission === null
                  ? 0
                  : parseFloat(booking.commission_booking.total_hotel_commission)
            };
            categories.push(newCategory);
          }
        }
      }

      // Prepare graph options and data
      let dataCommission = [];
      let labels = [];
      for (let category of categories) {
        labels.push(category.name);
        dataCommission.push(category.totalCommission.toFixed(2));
      }
      setDataCommission(dataCommission);
      setLabels(labels);
    }
    if (props.type === "CategoryExpenses") {
      for (let booking of bookings) {
        if (booking.event?.business_categories[0]) {
          let change = false;
          counter++;
          if (categories.length === 0) {
            let newCategory = {
              name: booking.event?.business_categories[0].display_name,
              totalRevenue: booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees)
            };
            categories.push(newCategory);
          }
          Loop1: for (let category of categories) {
            if (counter === 1) {
              change = true;
              break Loop1;
            }
            if (booking.event?.business_categories[0]?.display_name === category.name) {
              category.totalRevenue +=
                booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees);
              change = true;
            }
          }
          if (change === false) {
            let newCategory = {
              name: booking.event?.business_categories[0]?.display_name,
              totalRevenue: booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees)
            };
            categories.push(newCategory);
          }
        }
      }

      // Prepare graph options and data
      let dataExpenses = [];
      let labels = [];
      for (let category of categories) {
        dataExpenses.push(category.totalRevenue.toFixed(2));
        labels.push(category.name);
      }
      setDataExpenses(dataExpenses);
      setLabels(labels);
    }
    if (props.type === "CostCenterExpenses") {
      for (let booking of bookings) {
        if (booking?.booking_cost_center) {
          let change = false;
          counter++;
          if (categories.length === 0) {
            let newCategory = {
              name: booking.booking_cost_center?.number + " " + booking.booking_cost_center?.name,
              totalRevenue: booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees)
            };
            categories.push(newCategory);
          }
          Loop1: for (let category of categories) {
            if (counter === 1) {
              change = true;
              break Loop1;
            }
            if (booking.booking_cost_center?.number + " " + booking.booking_cost_center?.name === category.name) {
              category.totalRevenue +=
                booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees);
              change = true;
            }
          }
          if (change === false) {
            let newCategory = {
              name: booking.booking_cost_center?.number + " " + booking.booking_cost_center?.name,
              totalRevenue: booking.total_price_without_fees === null ? 0 : parseFloat(booking.total_price_without_fees)
            };
            categories.push(newCategory);
          }
        }
      }

      // Prepare graph options and data
      let dataCostCenter = [];
      let labels = [];
      let i = 1;
      for (let category of categories) {
        dataCostCenter.push(category.totalRevenue.toFixed(2));
        labels.push(category.name);
        i++;
      }
      setDataCostCenter(dataCostCenter);
      setLabels(labels);
    }
  };

  let data = {};
  if (props.type === "CategoryRevenue") {
    data = {
      labels: labels,
      datasets: [
        {
          backgroundColor: [
            theme.palette.custom.blueBaby,
            theme.palette.custom.blue,
            theme.palette.custom.turquoise,
            theme.palette.custom.greenLight,
            theme.palette.custom.yellow,
            theme.palette.custom.orange,
            theme.palette.custom.purple,
            theme.palette.custom.red,
            theme.palette.custom.grayDark,
            theme.palette.custom.grayBright
          ],
          data: dataRevenue
        }
      ]
    };
  }
  if (props.type === "CategoryCommission") {
    data = {
      labels: labels,
      datasets: [
        {
          backgroundColor: [
            theme.palette.custom.blueBaby,
            theme.palette.custom.blue,
            theme.palette.custom.turquoise,
            theme.palette.custom.greenLight,
            theme.palette.custom.yellow,
            theme.palette.custom.orange,
            theme.palette.custom.purple,
            theme.palette.custom.red,
            theme.palette.custom.grayDark,
            theme.palette.custom.grayBright
          ],
          data: dataCommission
        }
      ]
    };
  }
  if (props.type === "CategoryExpenses") {
    data = {
      labels: labels,
      datasets: [
        {
          backgroundColor: [
            theme.palette.custom.blueBaby,
            theme.palette.custom.blue,
            theme.palette.custom.turquoise,
            theme.palette.custom.greenLight,
            theme.palette.custom.yellow,
            theme.palette.custom.orange,
            theme.palette.custom.purple,
            theme.palette.custom.red,
            theme.palette.custom.grayDark,
            theme.palette.custom.grayBright
          ],
          data: dataExpenses
        }
      ]
    };
  }
  if (props.type === "CostCenterExpenses") {
    data = {
      labels: labels,
      datasets: [
        {
          backgroundColor: [
            theme.palette.custom.blueBaby,
            theme.palette.custom.blue,
            theme.palette.custom.turquoise,
            theme.palette.custom.greenLight,
            theme.palette.custom.yellow,
            theme.palette.custom.orange,
            theme.palette.custom.purple,
            theme.palette.custom.red,
            theme.palette.custom.grayDark,
            theme.palette.custom.grayBright
          ],
          data: dataCostCenter
        }
      ]
    };
  }
  const options = {
    events: ["click"],
    legend: {
      position: "right",
      labels: {
        boxWidth: 15,
        fontSize: 10,
        fontFamily: "Neutraface2Book"
      }
    }
  };

  return (
    <div>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default GraphCategorySplit;
